import { useQuery } from '@tanstack/react-query'
import { sessionService } from '../api/sessionService'
import { WAR_ROOM_QUERY_KEYS } from '../api/queryClient'

/**
 * Single session — refreshed every 30s as baseline,
 * real-time updates come via WebSocket + cache invalidation.
 */
export function useSession(sessionId: string) {
  return useQuery({
    queryKey: WAR_ROOM_QUERY_KEYS.session(sessionId),
    queryFn: () => sessionService.get(sessionId).then((r) => r.data),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    enabled: !!sessionId,
  })
}

/**
 * Session list — auto-refreshes every 60s.
 */
export function useSessions(params: { status?: string; page?: number; per_page?: number } = {}) {
  return useQuery({
    queryKey: [...WAR_ROOM_QUERY_KEYS.sessions(''), params] as const,
    queryFn: () => sessionService.list(params),
    staleTime: 60_000,
    placeholderData: (prev) => prev,
  })
}
